import { Component, OnInit } from '@angular/core';
import { FileService } from '../../services/file.service';
import { Methods } from '../../shared/methods';
import { DinamicData, Cell } from '../../models/dinamic-data';

@Component({
  selector: 'app-centralizedfile',
  templateUrl: './centralizedfiles.component.html',
  styleUrls: ['./centralizedfiles.component.css'],
  providers: [ FileService ]
})
export class CentralizedfilesComponent implements OnInit {

  public mtds: Methods = new Methods();

  public ponumber = '';
  public loading = false;
  public flat = false;
  public token;

  public data: DinamicData = new DinamicData([
    "Report Name",
    "Created at",
    "Location",
    "Actions",
  ]);

  constructor(public _fileService: FileService) {
    this.token = JSON.parse(localStorage.getItem('token'));
  }

  ngOnInit() {
  }

  getFolders() {
    this.loading = true;
    this.flat = true;
    this.data.rows = [];
    this._fileService.getPOfiles(this.ponumber).subscribe(
      (r) => {
        console.log(r);
        if (r.status == "success") {

          if (r.data) {
            for (let element of r.data) {
              const actionButtons = [
                // { icon: "remove_red_eye", action: "Show", color: "info", value: element.id },
                { icon: "remove_red_eye", action: "Download", color: "info", value: `https://itaderp.com/script-upload/${element.folder}/${element.file}` },
                // { icon: 'delete_outline', action: 'Remove', color: 'danger', value: element.id }
              ];

              this.data.rows.push([
                new Cell(element.file),
                new Cell(
                  element.createdAt != null
                    ? this.mtds.getFecha(
                        new Date(element.createdAt.timestamp * 1000),
                        "MM/dd/yyyy h:mm:ss"
                      )
                    : null, { type: 'full-date' }
                ),
                new Cell('CV Files'),
                new Cell(actionButtons, { type: "actions" })
              ]);
            }
          }

          if (r.data2) {
            for (let element of r.data2) {

              const actionButtons = [
                // { icon: "remove_red_eye", action: "Show", color: "info", value: element.id },
                { icon: "remove_red_eye", action: "Download", color: "info", value: `https://ha-software.com/backend/${element.folder}/${element.file}` },
                // { icon: 'delete_outline', action: 'Remove', color: 'danger', value: element.id }
              ];

              this.data.rows.push([
                new Cell(element.file),
                new Cell(element.fecha, { type: 'full-date' } ),
                new Cell('Processing Instructions'),
                new Cell(actionButtons, { type: "actions" })
              ]);
            }
          }

          if (r.data3) {
            for (let element of r.data3) {

              const fdr = JSON.parse(element.data);
              console.log(fdr);

              const actionButtons = [
                // { icon: "remove_red_eye", action: "Show", color: "info", value: element.id },
                { icon: "remove_red_eye", action: "Download", color: "info", value: `https://www.greenteksolutionsllc.com/backend/reports/view-report.php?id=${element.id}&typeReport=PHYSICALDESTRUCTION` },
                // { icon: 'delete_outline', action: 'Remove', color: 'danger', value: element.id }
              ];

              this.data.rows.push([
                new Cell(element.name),
                new Cell(
                  element.createdAt != null
                    ? this.mtds.getFecha(
                        new Date(element.createdAt.timestamp * 1000),
                        "MM/dd/yyyy h:mm:ss"
                      )
                    : null, { type: 'full-date' }
                ),
                new Cell('Physical Destruction Report'),
                new Cell(actionButtons, { type: "actions" })
              ]);
            }
          }



        }
        this.loading = false;
      }, (error) => {
        this.loading = false;
      }
    );
  }

  action(e) {
    console.log(e);

    switch (e.action) {
      // case 'Show':
      //   this._fileService.getFile(this.token, e.id). subscribe(
      //     response =>{
      //       console.log(response);
      //       this.loading = false;
      //       if(response.status == 'success'){
      //         window.open("https://itaderp.com/script-uploadcompany"+
      //           response.data.folder+"/"+response.data.file, "_blank")
      //       }
      //     },
      //     error => {
      //       console.log(<any>error);
      //     }
      //   );
      //   break;
      case 'Download':
        window.open(e.id, "_blank");
        break;
      case 'Remove':
        this._fileService.deleteFile(this.token, e.id).subscribe(
          response =>{
            if(response.status == 'success'){
              //this._router.navigate(['/']);
              this.getFolders();
            alert("Done");
            console.log("deleted");
            } else {
              alert("Error");
            }
          },
          error => {
            console.log(<any>error);
             alert("Error");
          }
        );
        break;

      default:
        break;
    }
  }

}
